module.exports = __webpack_public_path__ + "static/images/02f6f20d7757fb5ceab0809383dbe8e9.png";